var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "body-bg",
    style: `background: url(${_vm.bgImg}) center center / cover no-repeat;opacity:${_vm.opacity}`
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };